import { RefObject, useState } from 'react'
import { useGSAP } from '@gsap/react'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

import { useLenis } from '@/contexts/lenis'

const useInView = ({
  ref = undefined,
  start = 'top bottom',
  end = 'bottom top',
  once = false,
  markers = false,
  initialState = false
}: Partial<{
  ref: RefObject<HTMLElement>
  start: string | number | ScrollTrigger.StartEndFunc
  end: string | number | ScrollTrigger.StartEndFunc
  once: boolean
  markers: boolean
  initialState: boolean
}>) => {
  const [isInView, setInView] = useState(initialState)
  const { lenis } = useLenis()

  useGSAP(
    () => {
      if (!ref || !lenis) return
      ScrollTrigger.create({
        trigger: ref.current,
        start,
        end,
        once,
        markers,
        onEnter: () => setInView(true),
        onLeave: () => setInView(false),
        onEnterBack: () => setInView(true),
        onLeaveBack: () => setInView(false)
      })
    },
    { scope: ref, dependencies: [lenis] }
  )

  return isInView
}

export default useInView
